import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb } from './Breadcrumb';
import type { BreadcrumbItem } from './Breadcrumb';

export interface NavbarProps {
  breadcrumbs?: BreadcrumbItem[];
  rightContent?: ReactNode;
}

// Top header bar — extracted from the real app's layout/Navbar.jsx. Shows a
// plain page title when there's a single breadcrumb (or none), or the full
// Breadcrumb trail with a back button once a page has drilled down (e.g.
// /consent/:id, which pushes an extra crumb via useBreadcrumb()'s
// setPageCrumb). `rightContent` is a slot for page-specific actions.
export const Navbar = ({ breadcrumbs = [], rightContent }: NavbarProps) => {
  const navigate = useNavigate();
  const title = breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length - 1].label : 'Dashboard';
  const isDrilldown = breadcrumbs.length > 1;

  return (
    <header className="h-11 bg-white border-b border-[#b8c1d3] flex items-center justify-between px-6 sticky top-0 z-30">
      <div className="flex items-center gap-4">
        {isDrilldown ? (
          <Breadcrumb
            items={breadcrumbs}
            onBack={() => void navigate(breadcrumbs[0].path || '/')}
          />
        ) : (
          <h1 className="text-[14px] font-semibold text-[#242933]">{title}</h1>
        )}
      </div>

      <div className="flex items-center gap-2.5">
        {rightContent}
      </div>
    </header>
  );
};
